import React from 'react';
import { Link } from 'react-router-dom';
import './BelieveDaysPage.css';

// 👇 IMPORT YOUR BELIEVE LOGO HERE
import believeLogo from '../Assets/storyfest/belivelogo.png';

const BelieveDaysPage = () => {
  // ==========================================
  // 🎟️ UNIQUE TICKET LINKS FOR EACH DAY
  // Replace these with your actual day-specific links
  // ==========================================
  const DAY_1_LINK = "https://tickets.mojo-pay.com/events/storyfest-2026";
  const DAY_2_LINK = "https://tickets.mojo-pay.com/events/storyfest-2026-believe-experience-day-2"; 
  const DAY_3_LINK = "https://tickets.mojo-pay.com/events/storyfest-2026-believe-experience-day-3"; 

  const days = [
    {
      day: "Day 1",
      date: "Friday, 11th December 2026",
      time: "6:00 PM — 9:00 PM",
      theme: "The Awakening",
      link: DAY_1_LINK
    },
    {
      day: "Day 2",
      date: "Saturday, 12th December 2026",
      time: "6:00 PM — 9:00 PM",
      theme: "The Wonder",
      link: DAY_2_LINK
    },
    {
      day: "Day 3",
      date: "Sunday, 13th December 2026",
      time: "6:00 PM — 9:00 PM",
      theme: "The Finale",
      link: DAY_3_LINK
    }
  ];

  return (
    <div className="believe-days-page">
      
      {/* Background Texture */}
      <div className="believe-days-bg-pattern"></div>

      {/* Navigation */}
      <div className="believe-days-nav">
        <Link to="/storyfest" className="believe-days-back-link">← Back to StoryFest</Link>
      </div>

      <div className="believe-days-container">
        
        {/* Header Section (Logo + Subtitle) */}
        <div className="believe-days-header">
          <img 
            src={believeLogo} 
            alt="Believe Christmas Musical Logo" 
            className="believe-days-logo" 
          />
          <p className="believe-days-subtitle">
            Select the day you would like to experience the magic. 
            Each performance is a unique journey filled with music, storytelling, and wonder.
          </p>
        </div>

        {/* Days Grid */}
        <div className="believe-days-grid">
          {days.map((item, index) => (
            <div key={index} className="believe-day-card">
              
              <div className="believe-day-card-header">
                <h2 className="believe-day-title">{item.day}</h2>
                <span className="believe-day-theme">{item.theme}</span>
              </div>

              <div className="believe-day-info">
                <p className="believe-day-date">📅 {item.date}</p>
                <p className="believe-day-time">⏰ {item.time}</p>
              </div>

              <a 
                href={item.link} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="believe-day-btn"
              >
                Select This Day <span className="believe-day-arrow">↗</span>
              </a>

            </div>
          ))}
        </div>

        {/* Bottom Note */}
        <div className="believe-days-footer-note">
          <p>All performances take place at the Accra City Hotel. Doors open 30 minutes before showtime.</p>
        </div>

      </div>
    </div>
  );
};

export default BelieveDaysPage;